import Vue from "vue";
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faFacebook, faGooglePlay, faInstagram, faTelegram, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {faBell} from '@fortawesome/free-regular-svg-icons'
import {
    faAngleDown,
    faArrowRight,
    faBars,
    faBoxes,
    faBalanceScale,
    faCartArrowDown,
    faCalendarAlt,
    faChair,
    faChartBar,
    faChartLine,
    faClipboard,
    faDollyFlatbed,
    faEdit,
    faEraser,
    faEye,
    faFileInvoiceDollar,
    faFileImport,
    faFileExport,
    faFileInvoice,
    faHandshake,
    faHandHoldingUsd,
    faHome,
    faHourglassEnd,
    faInfoCircle,
    faLandmark,
    faLanguage,
    faMoneyCheckAlt,
    faPercentage,
    faPlus,
    faPrint,
    faPen,
    faReceipt,
    faRedo,
    faStarOfLife,
    faShoppingBag,
    faShoppingBasket,
    faShoppingCart,
    faSignInAlt,
    faSignOutAlt,
    faExpandArrowsAlt,
    faSearch,
    faTasks,
    faTimes,
    faTools,
    faTrash,
    faTruck,
    faTruckLoading,
    faUsersCog,
    faUserTie,
    faUndo,
    faWarehouse,
    faStoreAltSlash,
    faDumpster,
    faMinusCircle,
    faMinus,
    faDonate,
    faLayerGroup,
    faCartPlus,
    faUsers,
    faDollarSign,
    faCompressArrowsAlt,
    faCompressAlt,
    faCompress,
    faExpand,
    faSync,
    faChartPie,
    faChartArea,
    faUserPlus,
    faUserFriends,
    faArrowUp,
    faArrowDown,
    faBuilding,
    faSlidersH,
    faPencilAlt,
    faBan,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faArrowUp,
    faArrowDown,
    faAngleDown,
    faArrowRight,
    faBan,
    faBars,
    faBell,
    faBoxes,
    faBuilding,
    faBalanceScale,
    faBuilding,
    faCartArrowDown,
    faCalendarAlt,
    faChair,
    faChartBar,
    faChartLine,
    faChartPie,
    faChartBar,
    faChartArea,
    faClipboard,
    faUsers,
    faUserPlus,
    faCartPlus,
    faDollarSign,
    faDollyFlatbed,
    faDonate,
    faDumpster,
    faEdit,
    faEraser,
    faEye,
    faFacebook,
    faFileInvoiceDollar,
    faFileImport,
    faFileExport,
    faFileInvoice,
    faGooglePlay,
    faExpandArrowsAlt,
    faExpand,
    faCompressArrowsAlt,
    faCompressAlt,
    faCompress,
    faHandshake,
    faHome,
    faHourglassEnd,
    faHandHoldingUsd,
    faInfoCircle,
    faInstagram,
    faLandmark,
    faLanguage,
    faLayerGroup,
    faMinusCircle,
    faMinus,
    faMoneyCheckAlt,
    faPercentage,
    faPencilAlt,
    faPen,
    faPlus,
    faPrint,
    faPen,
    faReceipt,
    faRedo,
    faStarOfLife,
    faSync,
    faShoppingBag,
    faShoppingBasket,
    faShoppingCart,
    faSignInAlt,
    faSignOutAlt,
    faSearch,
    faStoreAltSlash,
    faStoreAltSlash,
    faSlidersH,
    faTasks,
    faTimes,
    faTrash,
    faTelegram,
    faTools,
    faTruck,
    faTruckLoading,
    faUsersCog,
    faUserTie,
    faUsers,
    faUserFriends,
    faUndo,
    faWarehouse,
    faYoutube,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
